import React from 'react'
import { utils } from 'alelo-logic'
import { renderTextInput, renderSelectField } from 'utils/renderInputs'
import { Field } from 'redux-form'

import { labels } from './data.json'

export default function validateConfirmPlate(value, { plate }) {
  if (!value) return 'Campo obrigatório'

  if (value !== plate) {
    return 'Placas não coincidem. Favor digitar novamente a placa e confirmá-la.'
  }
}

const AxisField = ({ axis }) => (
  <Field
    placeholder=" "
    component={renderSelectField}
    label={labels.axis}
    name="axis"
    options={axis}
    validate={utils.emptyFieldValidate}
  />
)

const PlateField = props => (
  <Field
    component={renderTextInput}
    label={labels.plate}
    name="plate"
    type="text"
    validate={utils.plateValidate}
    normalize={utils.plateMask}
    isRequired
    autoComplete="off"
    tooltip="O preenchimento deve ser exatamente igual a placa inserida no campo anterior"
    {...props}
  />
)

const ConfirmPlateField = props => (
  <Field
    component={renderTextInput}
    label={labels.confirmPlate}
    name="confirmPlate"
    type="text"
    validate={validateConfirmPlate}
    normalize={utils.plateMask}
    isRequired
    autoComplete="off"
    tooltip="O preenchimento deve seguir o padrão atual ABC1234 ou padrão placa Mercosul ABC1D23"
    {...props}
  />
)

const IdentifierField = props => (
  <Field
    component={renderTextInput}
    label={labels.identifier}
    name="identifier"
    type="text"
    validate={utils.identifierValidate}
    isRequired
    isFocus
    {...props}
  />
)

export { AxisField, PlateField, ConfirmPlateField, IdentifierField }



// WEBPACK FOOTER //
// ./src/app/pages/ActivationForPartner/form-fields.js